import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import EmptyComponent from "../../utils/EmptyComponent";
import TabPanel from "../../components/TabPanel";
import CustomExistingTemplates from "./custom-template/CustomExistingTemplates";
import CustomTab from "./custom-template/CustomTab";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function TemplatesAndSections({ tab }) {
  
  const [value, setValue] = useState(tab === "Standard" ? 0 : tab==="Moodletraining"?5:1);
    useEffect(() => {
    setValue(tab === "Standard" ? 0 : tab==="Moodletraining"?5:1);
  }, [tab]);
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div style={{ minwidth: "100%", backgroundColor: "#F9FAFB" }}>
        <h1 className="mx-3 mt-3" style={{ color: "rgb(0,0,0)" }}>
          Questionnaire Tool
        </h1>
      </div>
      <Tabs value={value} onChange={handleChange} variant="scrollable" sx={{ marginLeft: 3 }}>
        <Tab label="Standard" {...a11yProps(0)} style={{ textTransform: "inherit" }}  />
        <Tab label="Custom" {...a11yProps(1)} style={{ textTransform: "inherit" }} />
        <Tab label="Questions Bank" {...a11yProps(2)} style={{ textTransform: "inherit" }} />
        <Tab label="Assign Templates" {...a11yProps(3)} style={{ textTransform: "inherit" }} />
        <Tab label="Template Mapping" {...a11yProps(4)} style={{ textTransform: "inherit" }} />
     
      </Tabs>

      <TabPanel value={value} index={0}>
        <EmptyComponent />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CustomTab />
      </TabPanel>
 
    </>
  );
}
